/*@flow*/
import type { Element } from 'react';
import React from 'react';
import type { LocalsT } from '../types';
import cx from 'classnames';

export default function VerticalCols(
  props: LocalsT & { children: React$Node }
): any | Element<'div'> {
  const { vertical } = props.config;
  const className = vertical ? vertical.getInputClassName() : '';
  if (!vertical) return props.children || null;
  const row = Boolean(vertical);

  return (
    <div className={cx({ row })}>
      <div className={cx(className)}>{props.children || null}</div>
    </div>
  );
}
